export class SynthRole {
  /**
   * Role to enable L3 Onboarding toggle.
   */
  public static readonly SYNTH_L3_ONBOARDING_ROLE = 'SYNTH_L3_ONBOARDING_ROLE'
  /**
   * Role to enable ARB blockchain USDC.
   */
  public static readonly SYNTH_ARB_BLOCKCHAIN_ROLE = 'SYNTH_ARB_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_ARB_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_ARB_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable ALGO blockchain USDC.
   */
  public static readonly SYNTH_ALGO_BLOCKCHAIN_ROLE =
    'SYNTH_ALGO_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_ALGO_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_ALGO_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable APTOS blockchain USDC.
   */
  public static readonly SYNTH_APTOS_BLOCKCHAIN_ROLE =
    'SYNTH_APTOS_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_APTOS_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_APTOS_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable AVAX blockchain USDC.
   */
  public static readonly SYNTH_AVAX_BLOCKCHAIN_ROLE =
    'SYNTH_AVAX_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_AVAX_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_AVAX_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable BASE blockchain USDC.
   */
  public static readonly SYNTH_BASE_BLOCKCHAIN_ROLE =
    'SYNTH_BASE_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_BASE_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_BASE_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable BTC blockchain USDC.
   */
  public static readonly SYNTH_BTC_BLOCKCHAIN_ROLE = 'SYNTH_BTC_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_BTC_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_BTC_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable CELO blockchain USDC.
   */
  public static readonly SYNTH_CELO_BLOCKCHAIN_ROLE =
    'SYNTH_CELO_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_CELO_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_CELO_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable CODEX blockchain USDC.
   */
  public static readonly SYNTH_CODEX_BLOCKCHAIN_ROLE =
    'SYNTH_CODEX_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_CODEX_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_CODEX_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable ETH blockchain USDC.
   */
  public static readonly SYNTH_ETH_BLOCKCHAIN_ROLE = 'SYNTH_ETH_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_ETH_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_ETH_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable EVMOS blockchain USDC.
   */
  public static readonly SYNTH_EVMOS_BLOCKCHAIN_ROLE =
    'SYNTH_EVMOS_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_EVMOS_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_EVMOS_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable FLOW blockchain USDC.
   */
  public static readonly SYNTH_FLOW_BLOCKCHAIN_ROLE =
    'SYNTH_FLOW_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_FLOW_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_FLOW_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable HBAR blockchain USDC.
   */
  public static readonly SYNTH_HBAR_BLOCKCHAIN_ROLE =
    'SYNTH_HBAR_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_HBAR_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_HBAR_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable LINEA blockchain USDC.
   */
  public static readonly SYNTH_LINEA_BLOCKCHAIN_ROLE =
    'SYNTH_LINEA_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_LINEA_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_LINEA_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable MANA blockchain USDC.
   */
  public static readonly SYNTH_MANA_BLOCKCHAIN_ROLE =
    'SYNTH_MANA_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_MANA_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_MANA_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable MATIC blockchain USDC.
   */
  public static readonly SYNTH_MATIC_BLOCKCHAIN_ROLE =
    'SYNTH_MATIC_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_MATIC_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_MATIC_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable NEAR blockchain USDC.
   */
  public static readonly SYNTH_NEAR_BLOCKCHAIN_ROLE =
    'SYNTH_NEAR_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_NEAR_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_NEAR_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable NOBLE blockchain USDC.
   */
  public static readonly SYNTH_NOBLE_BLOCKCHAIN_ROLE =
    'SYNTH_NOBLE_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_NOBLE_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_NOBLE_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable OP blockchain USDC.
   */
  public static readonly SYNTH_OP_BLOCKCHAIN_ROLE = 'SYNTH_OP_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_OP_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_OP_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable PAH blockchain USDC.
   */
  public static readonly SYNTH_PAH_BLOCKCHAIN_ROLE = 'SYNTH_PAH_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_PAH_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_PAH_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable POLY blockchain USDC.
   */
  public static readonly SYNTH_POLY_BLOCKCHAIN_ROLE =
    'SYNTH_POLY_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_POLY_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_POLY_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable SOL blockchain USDC.
   */
  public static readonly SYNTH_SOL_BLOCKCHAIN_ROLE = 'SYNTH_SOL_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_SOL_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_SOL_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable SUI blockchain USDC.
   */
  public static readonly SYNTH_SUI_BLOCKCHAIN_ROLE = 'SYNTH_SUI_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_SUI_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_SUI_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable TRX blockchain USDC.
   */
  public static readonly SYNTH_TRX_BLOCKCHAIN_ROLE = 'SYNTH_TRX_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_TRX_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_TRX_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable UNI blockchain USDC.
   */
  public static readonly SYNTH_UNI_BLOCKCHAIN_ROLE = 'SYNTH_UNI_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_UNI_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_UNI_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable XLM blockchain USDC.
   */
  public static readonly SYNTH_XLM_BLOCKCHAIN_ROLE = 'SYNTH_XLM_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_XLM_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_XLM_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable XRP blockchain USDC.
   */
  public static readonly SYNTH_XRP_BLOCKCHAIN_ROLE = 'SYNTH_XRP_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_XRP_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_XRP_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable ZKS blockchain USDC.
   */
  public static readonly SYNTH_ZKS_BLOCKCHAIN_ROLE = 'SYNTH_ZKS_BLOCKCHAIN_ROLE'
  public static readonly SYNTH_ZKS_WITHDRAWAL_BLOCKCHAIN_ROLE =
    'SYNTH_ZKS_WITHDRAWAL_BLOCKCHAIN_ROLE'
  /**
   * Role to enable AVAX blockchain EURC.
   */
  public static readonly SYNTH_AVAX_BLOCKCHAIN_EURC_ROLE =
    'SYNTH_AVAX_BLOCKCHAIN_EURC_ROLE'
  public static readonly SYNTH_AVAX_WITHDRAWAL_BLOCKCHAIN_EURC_ROLE =
    'SYNTH_AVAX_WITHDRAWAL_BLOCKCHAIN_EURC_ROLE'
  /**
   * Role to enable ETH blockchain EURC.
   */
  public static readonly SYNTH_ETH_BLOCKCHAIN_EURC_ROLE =
    'SYNTH_ETH_BLOCKCHAIN_EURC_ROLE'
  public static readonly SYNTH_ETH_WITHDRAWAL_BLOCKCHAIN_EURC_ROLE =
    'SYNTH_ETH_WITHDRAWAL_BLOCKCHAIN_EURC_ROLE'
  /**
   * Role to enable XLM blockchain EURC.
   */
  public static readonly SYNTH_XLM_BLOCKCHAIN_EURC_ROLE =
    'SYNTH_XLM_BLOCKCHAIN_EURC_ROLE'
  public static readonly SYNTH_XLM_WITHDRAWAL_BLOCKCHAIN_EURC_ROLE =
    'SYNTH_XLM_WITHDRAWAL_BLOCKCHAIN_EURC_ROLE'
  /**
   * Role to enable SOL blockchain EURC.
   */
  public static readonly SYNTH_SOL_BLOCKCHAIN_EURC_ROLE =
    'SYNTH_SOL_BLOCKCHAIN_EURC_ROLE'
  public static readonly SYNTH_SOL_WITHDRAWAL_BLOCKCHAIN_EURC_ROLE =
    'SYNTH_SOL_WITHDRAWAL_BLOCKCHAIN_EURC_ROLE'
  /**
   * Role to enable BASE blockchain EURC.
   */
  public static readonly SYNTH_BASE_BLOCKCHAIN_EURC_ROLE =
    'SYNTH_BASE_BLOCKCHAIN_EURC_ROLE'
  public static readonly SYNTH_BASE_WITHDRAWAL_BLOCKCHAIN_EURC_ROLE =
    'SYNTH_BASE_WITHDRAWAL_BLOCKCHAIN_EURC_ROLE'
  /**
   * Role to enable custody policy.
   */
  public static readonly SYNTH_CUSTODY_POLICY_ROLE = 'SYNTH_CUSTODY_POLICY_ROLE'
  /**
   * Role to enable email approval method for wallet approval policy.
   */
  public static readonly SYNTH_EMAIL_APPROVAL_ROLE = 'SYNTH_EMAIL_APPROVAL_ROLE'
  /**
   * Role to determine if Periodic Reviews are enabled.
   */
  public static readonly SYNTH_PERIODIC_REVIEW_ROLE =
    'SYNTH_PERIODIC_REVIEW_ROLE'
  /**
   * Role to enable FX deposit and withdraw flow.
   */
  public static readonly SYNTH_FX_TRANSFERS_ROLE = 'SYNTH_FX_TRANSFERS_ROLE'
  /**
   * Role to enable Hong Kong specific features.
   */
  public static readonly SYNTH_HK_LAUNCH_ROLE = 'SYNTH_HK_LAUNCH_ROLE'
  /**
   * Role to enable FFC Memo in a bank account linking flow.
   */
  public static readonly SYNTH_FFC_MEMO_ROLE = 'SYNTH_FFC_MEMO_ROLE'
  /**
   * Role to enable in app notifications.
   */
  public static readonly SYNTH_IN_APP_NOTIFICATION_SECTION_ROLE =
    'SYNTH_IN_APP_NOTIFICATION_SECTION_ROLE'
  /**
   * Role to enable self-serve restricted API Key.
   */
  public static readonly SYNTH_RESTRICTED_API_KEY_ROLE =
    'SYNTH_RESTRICTED_API_KEY_ROLE'
  /**
   * Role to enable PIX account creation and use.
   */
  public static readonly SYNTH_PIX_ENABLED_ROLE = 'SYNTH_PIX_ENABLED_ROLE'
  /**
   * Role to enable onboarding flow.
   */
  public static readonly SYNTH_ONBOARDING = 'SYNTH_ONBOARDING'
  /**
   * Role to enable periodic review flow.
   */
  public static readonly SYNTH_PERIODIC_REVIEW = 'SYNTH_PERIODIC_REVIEW'
  /**
   * Role to enable modal takeover.
   */
  public static readonly SYNTH_TAKEOVER_ROLE = 'SYNTH_TAKEOVER_ROLE'
  /**
   * Role to enable modal takeover.
   */
  public static readonly SYNTH_BURN_FEE_V2_ENABLE_ROLE =
    'SYNTH_BURN_FEE_V2_ENABLE_ROLE'
  /**
   * Role to enable stripe.
   */
  public static readonly SYNTH_STRIPE_ENABLE_ROLE = 'SYNTH_STRIPE_ENABLE_ROLE'
  /**
   * Role to entity deposit limits.
   */
  public static readonly SYNTH_ENTITY_DEPOSIT_LIMITS =
    'SYNTH_ENTITY_DEPOSIT_LIMITS'
  /**
   * Role to entity deposit limits.
   */
  public static readonly SYNTH_ENTITY_WITHDRAWAL_LIMITS =
    'SYNTH_ENTITY_WITHDRAWAL_LIMITS'
  /**
   * Role to enable CUBIX account creation and use.
   */
  public static readonly SYNTH_CUBIX_ENABLED_ROLE = 'SYNTH_CUBIX_ENABLED_ROLE'
  /**
   * Role to enable travel rule France.
   */
  public static readonly SYNTH_TRAVEL_RULE_FRANCE_ENABLE_ROLE =
    'SYNTH_TRAVEL_RULE_FRANCE_ENABLE_ROLE'
  /**
   * Role to enable pending addresses for Travel Rule France customers.
   */
  public static readonly SYNTH_TRAVEL_RULE_FRANCE_ENABLE_PENDING_ADDRESSES_ROLE =
    'SYNTH_TRAVEL_RULE_FRANCE_ENABLE_PENDING_ADDRESSES_ROLE'
  /**
   * Role to enable fx express.
   */
  public static readonly SYNTH_FX_EXPRESS_ENABLE_ROLE =
    'SYNTH_FX_EXPRESS_ENABLE_ROLE'
  /**
   *
   * Role to enable Settlement Advance features.
   */
  public static readonly SYNTH_SETTLEMENT_ADVANCE_V2_ENABLE_ROLE =
    'SYNTH_SETTLEMENT_ADVANCE_V2_ENABLE_ROLE'
  /**
   *
   * Role to enable Liquidity Credit Service (LCS) for Settlement Advance.
   */
  public static readonly SYNTH_SETTLEMENT_ADVANCE_ENABLE_LCS_ROLE =
    'SYNTH_SETTLEMENT_ADVANCE_ENABLE_LCS_ROLE'
  /**
   *
   * Role to enable Transfer Type Selection on wallet approval workflow.
   */
  public static readonly SYNTH_WALLET_POLICY_TRANSFER_TYPE_SELECTION_ROLE =
    'SYNTH_WALLET_POLICY_TRANSFER_TYPE_SELECTION_ROLE'

  /**
   * Role to enable the migration from qualification data.
   */
  public static readonly SYNTH_QUALIFICATION_MIGRATION_ROLE =
    'SYNTH_QUALIFICATION_MIGRATION_ROLE'
  /**
   * Role to enable testing removing RFI resolve logic.
   */
  public static readonly SYNTH_REMOVE_RFI_RESOLVE_ROLE =
    'SYNTH_REMOVE_RFI_RESOLVE_ROLE'

  /**
   * Role to enable Swap features.
   */
  public static readonly SYNTH_SWAP_ENABLE_ROLE = 'SYNTH_SWAP_ENABLE_ROLE'

  /**
   * Role to enable API access by signing MSAs.
   */
  public static readonly SYNTH_MSA_API_ACCESS_ROLE = 'SYNTH_MSA_API_ACCESS_ROLE'

  /**
   * Role to enable billing profile page.
   */
  public static readonly SYNTH_BILLING_PROFILE_ENABLED =
    'SYNTH_BILLING_PROFILE_ENABLED'

  /**
   * Role to enable new approval workflow stage one features.
   */
  public static readonly SYNTH_NEW_APPROVAL_WORKFLOW_ONE =
    'SYNTH_NEW_APPROVAL_WORKFLOW_ONE'
}

export type SynthPermissionRole = keyof typeof SynthRole
